import React, { Component } from "react";
import CurrencyInput from "react-currency-input";

export default class Currency extends Component {
  render() {
    return (
      <CurrencyInput {...this.props} onChangeEvent={this.props.onChange} />
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Currency/index.js